/**
 * Pure helpers for TaskSearchSelect and Dependency Manager.
 */

/** @param {{ work_name?: string, vacancy?: string, sections?: string } | null | undefined} schedule */
export function getTaskName(schedule) {
  if (!schedule) return 'Без названия';
  return schedule.work_name || schedule.vacancy || schedule.sections || 'Без названия';
}

/** @param {Array<{id: number|string}>} tasks */
/** @param {number|string|null|undefined} value */
export function resolveSelectedTask(tasks, value) {
  if (value == null || value === '') return null;
  return (tasks || []).find((t) => Number(t.id) === Number(value)) || null;
}

/**
 * @param {Array<{id: number|string, work_name?: string, vacancy?: string, sections?: string, construction_stage?: string}>} tasks
 * @param {string} query
 * @param {{ excludeId?: number|string|null }} [opts]
 */
export function filterTasksByQuery(tasks, query, opts = {}) {
  const excludeId = opts.excludeId;
  let list = [...(tasks || [])];
  if (excludeId != null && excludeId !== '') {
    list = list.filter((t) => Number(t.id) !== Number(excludeId));
  }
  const q = (query || '').trim().toLowerCase();
  if (q) {
    list = list.filter((t) => {
      const name = getTaskName(t).toLowerCase();
      const stage = (t.construction_stage || '').toLowerCase();
      return name.includes(q) || stage.includes(q);
    });
  }
  return list.sort((a, b) =>
    getTaskName(a).localeCompare(getTaskName(b), 'ru', { sensitivity: 'base' })
  );
}

/**
 * @param {Array<{schedule_type?: string, construction_stage?: string}>} tasks
 * @param {{ type?: string, stage?: string }} filters
 */
export function filterTasksByTypeStage(tasks, filters = {}) {
  const { type, stage } = filters;
  return (tasks || []).filter((s) => {
    if (type && s.schedule_type !== type) return false;
    if (stage && s.construction_stage !== stage) return false;
    return true;
  });
}

/**
 * @param {Array<{
 *   predecessor_id?: number,
 *   successor_id?: number,
 *   predecessor_name?: string,
 *   successor_name?: string,
 *   predecessor_type?: string,
 *   successor_type?: string,
 *   predecessor_stage?: string,
 *   successor_stage?: string
 * }>} deps
 * @param {{ type?: string, stage?: string, query?: string }} filters
 */
export function filterDependencies(deps, filters = {}) {
  const { type, stage, query } = filters;
  const q = (query || '').trim().toLowerCase();
  return (deps || []).filter((d) => {
    if (type) {
      const matchType =
        d.predecessor_type === type || d.successor_type === type;
      if (!matchType) return false;
    }
    if (stage) {
      const matchStage =
        d.predecessor_stage === stage || d.successor_stage === stage;
      if (!matchStage) return false;
    }
    if (q) {
      const hay = `${d.predecessor_name || ''} ${d.successor_name || ''}`.toLowerCase();
      if (!hay.includes(q)) return false;
    }
    return true;
  });
}

/** @param {string|null|undefined} value */
export function formatScheduleDate(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('ru-RU');
}

/**
 * @param {{
 *   fromId?: number|string|null,
 *   toId?: number|string|null,
 *   dependencies?: Array<{predecessor_id: number, successor_id: number}>
 * }} args
 * @returns {string|null} reason why create is disabled, or null if ok
 */
export function composerDisableReason({ fromId, toId, dependencies } = {}) {
  if (fromId == null || fromId === '' || toId == null || toId === '') {
    return 'Выберите обе задачи';
  }
  if (Number(fromId) === Number(toId)) {
    return 'Нельзя связать задачу саму с собой';
  }
  const dup = (dependencies || []).some(
    (d) =>
      Number(d.predecessor_id) === Number(fromId) &&
      Number(d.successor_id) === Number(toId)
  );
  if (dup) return 'Такая связь уже существует';
  return null;
}
